import { IconButton, Link } from "@chakra-ui/react";

export const SocialButton = (props) => {
  const { icon, link, ...buttonProps } = props;
  return (
    <IconButton 
      {...buttonProps} 
      _hover={{bg: "transparent"}} 
      _active={{bg: "transparent"}}
      bg="transparent" 
      fontSize="30" 
      color="#C4C4C4" 
      icon={icon}
      as={Link}
      isExternal
      href={link}
    />
  )
}